import { View, Text, StyleSheet, Switch } from "react-native";
import React, { useState } from "react";
import RangeSliderComponent from "../../../../../components/GlobalComponents/Sliders/RangeSliderComponent";

export default function DistanceFilter({
  filters,
  setFilters,
}: {
  filters: any;
  setFilters: any;
}) {
  const [firstValue, setFirstValue] = useState(0);
  const [secondValue, setSecondValue] = useState(100);
  const [isEnabled, setIsEnabled] = useState(false);
  const [unit, setUnit] = useState("km");

  const handleFromValueChange = (value: any) => {
    // Handle from value change logic for distance
    setFirstValue(value);
  };

  const handleToValueChange = (value: any) => {
    setSecondValue(value);
    if (value !== undefined) {
      setFilters((prevFilters: any) => ({
        ...prevFilters,
        basicFilters: {
          ...prevFilters.basicFilters,
          maxDistance: value,
        },
      }));
    }
    else{
      setFilters((prevFilters: any) => ({
        ...prevFilters,
        basicFilters: {
          ...prevFilters.basicFilters,
          maxDistance: 100,
        },
      }));
    }
  };

  const toggleSwitch = () => {
    setIsEnabled((previousState) => !previousState);
    setUnit((prevUnit) => (prevUnit === "km" ? "mi" : "km"));
  };

  const formatLabel = (value: number) => {
    return `${value} ${unit}`;
  };

  return (
    <View>
      <RangeSliderComponent
        min={0}
        max={100}
        initialFromValue={0}
        initialToValue={100}
        onFromValueChange={handleFromValueChange}
        onToValueChange={handleToValueChange}
      />
      <View style={styles.valueLabelsContainer}>
        <Text style={styles.valueLabel}>{formatLabel(firstValue)}</Text>
        <Text style={styles.valueLabel}>{formatLabel(secondValue)}</Text>
      </View>

      <View
        style={{
          marginTop: 20,
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          position: "relative",
          marginRight: 15,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              position: "absolute",
              left: 3,
              zIndex: 1,
              fontSize: 12,
            }}
          >
            km
          </Text>
          <Switch
            trackColor={{
              true: "#F0EEED",
              false: "black",
            }}
            thumbColor={"#FDFBF9"}
            onValueChange={toggleSwitch}
            value={isEnabled}
            style={{ transform: [{ scale: 1.2 }] }}
          />
          <Text
            style={{
              position: "absolute",
              right: 3,
              fontSize: 12,
            }}
          >
            mi
          </Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  valueLabelsContainer: {
    width: "100%",
    display: "flex",
    marginTop: -45,
    paddingHorizontal: 15,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  valueLabel: {
    color: "black",
  },
});
